import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import GridBackground from './GridBackground';
import gameData from '../gameData';
import GridForeground from './GridForeground';
import DrawGrid from './DrawGrid';

export default class DrawArea extends Phaser.GameObjects.Container {
  constructor(scene, gridSize) {
    super(scene);

    this.bg = ABCyaPhaser.Images.addImage(0, 0, 'work-area-bg', this).setOrigin(0)
      .setInteractive({ draggable: true });

    const maxAreaWidth = this.scene.mid.x * 2 - 45;
    const maxAreaHeight = this.scene.mid.y * 2 - 120;
    const squaresPerWidth = gridSize;
    const squareSize = maxAreaWidth / gridSize;
    const squaresPerHeight = Math.floor(maxAreaHeight / squareSize);

    const areaBg = this.scene.add.rectangle(0, 0, squaresPerWidth * squareSize,squaresPerHeight * squareSize, '0xFFFFFF').setOrigin(0);
    this.add(areaBg);

    this.gridBgDisplay = new GridBackground(this.scene, squareSize,squaresPerWidth,squaresPerHeight);
    this.add(this.gridBgDisplay);

    this.drawGrid = new DrawGrid(this.scene, squareSize,squaresPerWidth,squaresPerHeight);
    this.add(this.drawGrid);

    this.gridFgDisplay = new GridForeground(this.scene, squareSize,squaresPerWidth,squaresPerHeight);
    this.add(this.gridFgDisplay);

    // fit draw area background to grid
    const adjustedWidth = squareSize * gridSize;
    const adjustedHeight = squareSize * squaresPerHeight;

    this.bg.scaleX = (adjustedWidth + 21) / this.bg.getBounds().width;
    this.bg.scaleY = (adjustedHeight + 21) / this.bg.getBounds().height;
    this.bg.x = -7 * this.bg.scaleX;
    this.bg.y = -7 * this.bg.scaleY;

    this.areaWidth = squareSize * squaresPerWidth;
    this.areaHeight = squareSize * squaresPerHeight;

    this.bg.on(Phaser.Input.Events.GAMEOBJECT_DRAG_START, this.paint, this);
    this.bg.on(Phaser.Input.Events.GAMEOBJECT_DRAG, this.paint, this);
    this.bg.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, this.saveAction,this);
  }

  paint(pointer) {
    const drawColor = gameData.CURRENT_TOOL === 'eraser' ? '' : gameData.DRAW_COLOR;

    this.drawPixels(
      pointer.x - this.x,
      pointer.y - this.y,
      gameData.CURRENT_TOOL,
      gameData.DRAW_SIZE,
      drawColor
    );
  }

  getPrintable() {
    const rt = new Phaser.GameObjects.RenderTexture(this.scene, 0,0, Math.ceil(this.areaWidth), Math.ceil(this.areaHeight));
    rt.draw(this.drawGrid.realGridContainer, 0, 0);

    return rt;
  }

  saveAction() {
    this.drawGrid.saveAction();
  }

  toggleGrid() {
    this.gridBgDisplay.alpha = this.gridBgDisplay.alpha === 1 ? 0 : 1;
    this.gridFgDisplay.alpha = this.gridBgDisplay.alpha;
    this.drawGrid.fakeBg.grid.alpha = this.gridBgDisplay.alpha;
  };

  drawPixels(x,y,tool,size,color) {
    this.drawGrid.drawOnGrid(x,y,tool,size,color);
  };
}